import { createContext, useContext } from 'react';
import type { AssistantBriefKind } from '@/api/assistantProactive/assistantProactiveApi.types';

export type AssistantPanelView = 'chat' | 'history' | 'voice';

export interface AssistantPanelContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  toggle: () => void;
  view: AssistantPanelView;
  setView: (view: AssistantPanelView) => void;
  conversationId: string | null;
  selectConversation: (conversationId: string | null) => void;
  aboutContext: string | null;
  askAbout: (aboutContext: string, question: string) => void;
  pendingQuestion: string | null;
  consumePendingQuestion: () => string | null;
  requestBrief: (kind: AssistantBriefKind) => void;
  pendingBriefKind: AssistantBriefKind | null;
  consumePendingBrief: () => AssistantBriefKind | null;
  isAutoNavigateEnabled: boolean;
  setAutoNavigateEnabled: (isEnabled: boolean) => void;
}

export const AssistantPanelContext = createContext<AssistantPanelContextValue | null>(null);

export function useOptionalAssistantPanel(): AssistantPanelContextValue | null {
  return useContext(AssistantPanelContext);
}

export function useAssistantPanel(): AssistantPanelContextValue {
  const context = useContext(AssistantPanelContext);
  if (context === null) {
    throw new Error('useAssistantPanel must be used inside AssistantPanelProvider');
  }
  return context;
}
